import { Slide } from '../types'
import getRequitedNotFilledFieldIds from './getRequitedNotFilledFieldIds'
import { Scope } from './makeSeparatorScopes'

export default function getSlides(scopes: Scope[]) {
  const slidesMap: Record<number, Slide> = {}

  scopes.forEach((scope, index) => {
    const requiredDataIds = getRequitedNotFilledFieldIds(scope.sections)
    slidesMap[index] = { isFilled: requiredDataIds.length === 0, requiredDataIds }
  })

  return slidesMap
}
